
export const commonLabels = {
    // Lost item status labels
    open: "Open",
    pending: "Pending",
    review: "Review",
    inProcess: "In Process", // Same name used for Column
    lFNotified: "LF Notified", // Same name used for Column
    closed: "Closed", // Legacy reference
    deleted: "Deleted",
    draftIncomplete: "Draft Incomplete",
    draftCompleted: "Draft Completed",
    notPaid: "Not Paid",
    overdue: "Overdue",
    shipMatch: "Ship Match", // Same name used for Column
    preMatch: "Pre-Match",
    finalMatch: "Final Match", // Same name used for Column
    readyToShip: "Ready to Ship", // Same name used for Column
    shipped: "Shipped", // Same name used for Column
    delete: "Delete",

    // Found item status labels
    found: "Found",
    discard: "Discard",

    // Column labels
    foundItems: "Found Items",
    urgent: "Urgent",
    columnOpen: "Open",
    columnPending: "Pending",
    columnReview: "Review",
    preMatched: "Pre-Matched",
    deleteddd: "Deleted",
    discarded: "Discarded"
};
